import { Box, Fade, IconButton, Typography } from '@mui/material'
import RenderServiceIcon from 'components/RenderServiceIcons/RenderServiceIcon'
import GroboticTextField from 'components/ui/grobotic-text-field'
import { toNumber } from 'components/DataGrid/operators/formatNumbers'
import { CustomProductDraft } from 'types'
const ProductDraftItem = ({
  draft,
  onChange,
  onRemove,
}: {
  draft: CustomProductDraft
  onChange: (patch: Partial<CustomProductDraft>) => void
  onRemove: () => void
}) => {
  return (
    <Box
      sx={{
        display: 'grid',
        alignItems: 'center',
        columnGap: 1,
        width: '100%',
        gridTemplateColumns: `
          minmax(220px, 1fr)
          120px
          120px
          1fr
          40px
        `,
      }}
    >
      <Box sx={{ minWidth: 0 }}>
        <RenderServiceIcon service={draft.productName} size={{ height: 14, width: 14, fontSize: 12, marginLeft: 0 }} />
      </Box>

      {/* <TextField
        size="small"
        label="Margin"
        value={draft.margin}
        onChange={e => onChange({ margin: Number(e.target.value) || 0 })}
        inputProps={{ inputMode: 'decimal' }}
      /> */}
      <Fade in={true} timeout={{ enter: 200, exit: 120 }}>
        <div>
          <GroboticTextField
            label="Margin"
            value={draft.margin ? toNumber(draft.margin) : 0}
            onChange={e => onChange({ margin: Number(e.target.value) || 0 })}
            size="small"
            sx={{ width: '100%' }}
            placeholder="Margin"
            inputprops={{ inputMode: 'decimal' }}
            showExtras={true}
            fadetime={7}
          />
        </div>
      </Fade>
      <Fade in={true} timeout={{ enter: 400, exit: 120 }}>
        <div>
          <GroboticTextField
            label="Price"
            value={draft.price ? toNumber(draft.price) : 0}
            onChange={e => onChange({ price: Number(e.target.value) || 0 })}
            size="small"
            sx={{ width: '100%' }}
            placeholder="Price"
            inputprops={{ inputMode: 'decimal' }}
            showExtras={true}
            fadetime={7}
          />
        </div>
      </Fade>

      <Typography noWrap sx={{ textAlign: 'right', fontSize: 12 }}>
        {draft.category || 'No category'}
      </Typography>

      <IconButton size="small" onClick={onRemove}>
        ✕
      </IconButton>
    </Box>
  )
}

export default ProductDraftItem
